import type { GetFriendsAndFamilyResponse } from '../get/types/get-friends-and-family.type';
import { postGenericEndpoint } from './post.api';
import type { PostGenericEndpointParams } from './post.api';
import type { PostFriendFamilyFindRequest } from './types';

export const postFriendsFamilyFind = async ({
	data,
	lang,
	token,
}: PostGenericEndpointParams<PostFriendFamilyFindRequest>) => {
	return await postGenericEndpoint<
		PostFriendFamilyFindRequest,
		GetFriendsAndFamilyResponse
	>({ data, path: 'friends-and-family/find', lang, token });
};
